import script from "./FooterBeplanet.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterBeplanet.vue?vue&type=script&setup=true&lang=js"

import "./FooterBeplanet.vue?vue&type=style&index=0&id=20f38b60&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20f38b60"]])

export default __exports__